import React from 'react'
import BackArrowIcon from 'assets/svg/BackArrow'
import { ReactComponent as SuccessTick } from 'assets/svg/SuccessTick.svg'
import useNavigation from 'hooks/useNavigation'
import { Drawers, OperationType } from 'store/drawer/types'
import wrapper from 'components/organisms/Drawers/wrapper'
import {
  Drawer as DrawerStyled,
  Container,
  Header,
  BackButton,
  Title,
  Content,
  IconContainer,
  SuccessTitle,
  Message,
  LinkButton,
  ActionButton,
  RefundMessage
} from './styles'
import { useAppSelector } from 'hooks/redux'

interface DrawerDebinOperationSuccessProps {
  showDrawer: boolean
  onClose: () => void
}

const DrawerDebinOperationSuccess: React.FC<DrawerDebinOperationSuccessProps> = ({
  showDrawer,
  onClose
}) => {
  const { onNavigate } = useNavigation()
  const { data } = useAppSelector(state => state.drawer)
  const drawerData = data[Drawers.DEBIN_OPERATION_SUCCESS]
  const isRefund = drawerData?.debinData?.isRefund
  const operationType = drawerData?.debinData?.operationType
  const isAccepted = drawerData?.debinData?.isAccepted

  const handleVolverInicio = () => {
    onClose()
    onNavigate('/content/wallet')
  }

  const acceptation = isAccepted ? 'Aceptaste' : 'Rechazaste'

  return (
    <DrawerStyled open={showDrawer} onClose={onClose} direction="right">
      <Container>
        <Header>
          <BackButton type="button" onClick={onClose}>
            <BackArrowIcon />
          </BackButton>
          <Title>Pago DEBIN</Title>
        </Header>

        <Content>
          <IconContainer>
            <SuccessTick />
          </IconContainer>

          <SuccessTitle>¡Listo!</SuccessTitle>

          <Message>
            {operationType === OperationType.DEBIN_CANCELATION
              ? 'Cancelaste el DEBIN programado.'
              : `${acceptation} el DEBIN`}
          </Message>

          {isRefund && (
            <RefundMessage>
              El reembolso se acreditará en breve.
            </RefundMessage>
          )}

          <LinkButton onClick={handleVolverInicio}>
            Volver a inicio
          </LinkButton>

          <ActionButton onClick={onClose}>
            Ir a Pago con DEBIN
          </ActionButton>
        </Content>
      </Container>
    </DrawerStyled>
  )
}

export default wrapper(DrawerDebinOperationSuccess, Drawers.DEBIN_OPERATION_SUCCESS)
